var _excluded = ["children", "color", "weight", "decoration", "transform", "as", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { j as n } from "./index.es33.js";
import { forwardRef as x } from "react";
import { clsx as c } from "./index.es105.js";
import { addInlineStyles as d } from "./index.es480.js";
import j from "./index.es491.js";
var w = /*#__PURE__*/x(function (_ref, f) {
  var r = _ref.children,
      o = _ref.color,
      s = _ref.weight,
      m = _ref.decoration,
      t = _ref.transform,
      _ref$as = _ref.as,
      l = _ref$as === void 0 ? "span" : _ref$as,
      a = _ref.className,
      e = _ref.style,
      p = _objectWithoutProperties(_ref, _excluded);

  var i = l;
  return n.jsx(i, _objectSpread(_objectSpread({
    className: c(j.small, a),
    style: d({
      color: o,
      weight: s,
      decoration: m,
      transform: t,
      style: e
    }),
    ref: f
  }, p), {}, {
    children: r
  }));
});
export { w as Small };